<template>
  <div class="flow-totals-charts">
    <div class="columns">
      <div class="column is-one-third-widescreen">
        <div class="island">
          <TotalsDoughnutChart
            class="totals-doughnut-chart"
            title="Most Completed"
            sub-title="Total Completed"
            :max-items="10"
            :loaded-data="isDataLoaded"
            :loading-error="loadingError"
            :data="data"
            series="Completed"
          />
        </div>
      </div>
      <div class="column is-one-third-widescreen">
        <div class="island">
          <TotalsDoughnutChart
            class="totals-doughnut-chart"
            title="Most Escalated"
            sub-title="Total Escalated"
            :max-items="10"
            :loaded-data="isDataLoaded"
            :loading-error="loadingError"
            :data="data"
            series="HandedOver"
          />
        </div>
      </div>
      <div class="column is-one-third-widescreen">
        <div class="island">
          <TotalsDoughnutChart
            class="totals-doughnut-chart"
            title="Most Abandoned"
            sub-title="Total Abandoned"
            :max-items="10"
            :loaded-data="isDataLoaded"
            :loading-error="loadingError"
            :data="data"
            series="Abandoned"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import TotalsDoughnutChart from './TotalsDoughnutChart.vue';
import { useFlowReport } from '@/features/reports/components/flows/useFlowReport';
import { ReportType } from '@/features/reports/models/reportType';
import { watch } from 'vue';

const emit = defineEmits<{
  (e: 'loaded'): void;
}>();

const { isDataLoaded, loadingError, data } = useFlowReport(ReportType.FLOW_TOTALS);
watch([isDataLoaded, loadingError], () => {
  if (isDataLoaded.value) emit('loaded');
});
</script>

<style lang="scss">
@media (max-width: 1450px) {
  .flow-totals-charts {
    .legend-container {
      display: none !important;
    }
    .doughnut-chart-container {
      margin: auto;
    }
  }
}
</style>

<style scoped lang="scss">
.flow-totals-charts {
  display: flex;
  flex-direction: column;

  .container.is-fluid {
    margin-left: 0;
    margin-right: 1px;
  }
}

.totals-doughnut-chart {
  display: flex;
  flex-direction: column;
  flex: 1;
}

.island {
  height: 370px;
  display: flex;
}
</style>
